import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { spacing8 } from 'approot/shared/styles/spacing.style';
import { grey2, grey7 } from 'approot/shared/styles/colours.style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { font14 } from 'approot/shared/styles/typography.style';
import { LabelStyled } from 'approot/shared/styles/inputs.style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';

export const ImagePickerButtonContainer = styled.div`
  text-align: center;
`;

export const ImagePickerContainer = styled.div`
  ${flexCentreAlignCss}
  margin-bottom: ${rem(spacing8)};
`;

export const ImagePickerDisabledOverlay = styled.div`
  background-color: rgba(255, 255, 255, 0.4);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  &:hover {
    cursor: not-allowed;
  }
`;

type ImagePickerEditorProps = {
  $width?: number;
  $height?: number;
};

export const ImagePickerEditor = styled.div<ImagePickerEditorProps>`
  background-color: ${grey2};
  border-radius: ${rem(borderRadius8)};
  position: relative;
  width: ${({ $width }) => ($width ? rem($width) : rem(200))};
  height: ${({ $height }) => ($height ? rem($height) : rem(200))};
`;

export const ImagePickerActions = styled.div`
  position: absolute;
  top: ${rem(spacing8)};
  right: ${rem(spacing8)};
  z-index: 1;
`;

export const ImagePickerHelpText = styled(LabelStyled)`
  ${font14}
  color: ${grey7};
`;
